<template>

<div>
  <b-navbar class="navi-bar" toggleable="lg" fixed="top">
    <b-navbar-brand href="#">
<div>
               <img id="navbarlogo" class="text-center" src="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Flogo%2Fprint_4c_transportpng.png?alt=media&token=aaeb89c5-5950-4bd0-bf0c-635d8ba2492a">
               </div>

    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="">
        <b-nav-item href="#"><router-link to="/">Home</router-link></b-nav-item>
        <b-nav-item href="#"><router-link to="/wiefunktionierts">Wie funktioniert's?</router-link></b-nav-item>
        <b-nav-item href="#"><router-link to="/tippszumkauf">Tipps zum Kauf</router-link></b-nav-item>
        <b-nav-item href="#"><router-link to="/faq">FAQ</router-link></b-nav-item>
        <b-nav-item href="#"><router-link to="/transportauftrag">Transportauftrag</router-link></b-nav-item>
        <b-nav-item href="#"><router-link to="/legal">Legal</router-link></b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
    </b-collapse>
  </b-navbar>
</div>
</template>

<script>
import { BNavbar, BCollapse, BNavbarNav, BNavItem, BNavbarToggle, BNavbarBrand } from 'bootstrap-vue'

export default {
  name: "navbarsection",
  components: {
    BNavbar, BCollapse, BNavbarNav, BNavItem, BNavbarToggle, BNavbarBrand
  },
  data() {
    return {
      toggle: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scss>
#bars {
  padding-top: 0.5rem;
  padding-right: 1rem;
  width: 40px;
}
a.nav-link {
  font-size: 1.3rem;
}


.navbar-nav {
 justify-content: center;
 flex: 1;
  }

 .nav-item {
  margin: 0rem 1rem 0rem 1rem;
  font-weight: 500;
}

@media (min-device-width: 800px) {
.side-nav .collapsible a, .fas .far {
  font-size: 2rem;
  height: 3rem;
}}
#navbarlogo{
  width: 12rem;
  display:none;
}

body {
  background-color: #141414;
  color: #efefef;
}

body h2, h1 {
  font-size: 4rem;
  color: #2196f3 !important;
}

.navi-bar {
 /* background-color: #1976d2 !important; opacity:0.4; */
 background-color: rgba(31, 31, 31, 0.95); opacity: 1; 
}
#baricon {
  display: flex;
  flex-direction: row;
}

#h5 {
  font-size: 2rem;
}
.side-nav.wide {
  width: 75%;
}

span,
a {
  color: white !important;
}
.ripple-parent,
.nav-link a {
  color: white !important;
}

#white-mod {
  color: white !important;
}

</style>